{
  "todayButton": "今天",
  "nextMonth": "下个月",
  "previousMonth": "前一个月",
  "nextYear": "明年",
  "previousYear": "去年",
  "weekdays": [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六"
  ],
  "months": [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}
